import { Component, Input } from '@angular/core';

@Component({
  selector: 'kion-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent {

  //project defines layout via scss
  @Input() project: 'LR' | 'FS' | 'Dematic' | string;
  //title
  @Input() title: { title: string, titleSize: string };
  //description => markdown support
  @Input() description: string;
}
